import * as React from 'react'

export const PendulumNaked = (props: React.ComponentProps<'svg'>) => (

    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 64 64" {...props}>
        <g>
            <path fill="#907ea0" d="M33.2,5.1c-10.9-.2-20.3,8.7-20.5,19.6-.2,7.4,3.6,13.9,9.4,17.6.3.2.7,0,.8-.2l4.5-9c.7-1.3.6-2.9-.3-4.2-.7-1.1-1.1-2.4-1.1-3.7,0-3.5,2.8-6.4,6.3-6.6,4.1-.2,7.4,3.2,7.1,7.2-.3,3.3-2.9,5.9-6.2,6.2h0c-1.5.1-2.8,1-3.5,2.3l-4.5,9c-.1.3,0,.7.3.8,2.3.9,4.8,1.3,7.4,1.3,11,0,20-9.1,20-20.1,0-11-8.8-20-19.8-20.2Z"/>
            <circle fill="#907ea0" cx="19.5" cy="52.2" r="6.7"/>
        </g>
    </svg>
)

